<div class="meeting-form-shell">
  <div class="container-fluid">

    <!-- Page header -->
    <div class="admin-page-header meeting-form-header">
      <div class="meeting-form-title">
        <h3>Meeting Form</h3>
        <div class="meeting-form-project" *ngIf="project">
          <img class="project-pic"
               src="https://hsbooster.eu{{ project.picture }}"
               onerror="this.src='/assets/img/1177568.png'" alt="">
          <div class="project-meta">
            <div class="project-line-1">
              <strong>{{ project.project_acronym }}</strong>
              <span class="project-name" *ngIf="project.name || project.surname">
                · <span *ngIf="project.version == 'v2'">{{ project.title }} </span>{{ project.name }} {{ project.surname }}
              </span>
            </div>
            <div class="project-line-2">
              <span *ngIf="project.organisation_type">{{ project.organisation_type }}</span>
              <span *ngIf="project.email"> · {{ project.email }}</span>
            </div>
          </div>
        </div>
      </div>

      <a href="https://www.hsbooster.eu/training-academy" target="_blank"
         class="btn btn-sm btn-action training-link">
        <i class="fa fa-external-link"></i>
        Visit Training Academy
      </a>

      <a href="https://sot.hsbooster.eu" target="_blank"
         class="btn btn-sm btn-action training-link">
        <i class="fa fa-external-link"></i>
        SOT
      </a>
    </div>

    <!-- Progress stepper -->
    <div class="stepper">
      <div class="stepper-track">
        <div class="stepper-fill" [ngStyle]="{'width': getProgressBar()}"></div>

        <div class="step" [class.active]="getCircleState(1) === 'active'"
             (click)="goToMeetingStep(0, 'first')">
          <span class="step-circle">1</span>
          <span class="step-label">1st Meeting</span>
        </div>
        <div class="step" [class.active]="getCircleState(2) === 'active'"
             (click)="goToMeetingStep(1, 'first')">
          <span class="step-circle">2</span>
          <span class="step-label">2nd Meeting<span *ngIf="isPss()"> (optional)</span></span>
        </div>
        <div *ngIf="!isPss()" class="step" [class.active]="getCircleState(3) === 'active'"
             (click)="goToMeetingStep(2, 'first')">
          <span class="step-circle">3</span>
          <span class="step-label">3rd Meeting</span>
        </div>
        <div class="step" [class.active]="getCircleState(4) === 'active'"
             (click)="goToMeetingStep(3, 'first')">
          <span class="step-circle">A</span>
          <span class="step-label">Advice</span>
        </div>
        <div class="step" [class.active]="getCircleState(5) === 'active'"
             (click)="goToMeetingStep(4, 'first')">
          <span class="step-circle">{{ isPss() ? 'C' : 'F' }}</span>
          <span class="step-label">{{ isPss() ? 'Closure' : 'Final' }}</span>
        </div>
      </div>

      <div class="stepper-survey">
        <div class="step step--survey" [class.active]="getCircleState(6) === 'active'"
             (click)="goToMeetingStep(5, 'survey')">
          <span class="step-circle"><i class="fa fa-check"></i></span>
          <span class="step-label">Survey</span>
        </div>
      </div>
    </div>

  </div>
</div>

<router-outlet *ngIf="ready" name="meeting-form"></router-outlet>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
